import { getEnvVar } from '@mc/client-env'

export const getArticleIndex = () => getEnvVar('ALGOLIA_ARTICLE_INDEX_NAME')

export const getCampIndex = () => getEnvVar('ALGOLIA_CAMP_INDEX_NAME')

export const getChapterIndex = () => getEnvVar('ALGOLIA_CHAPTER_INDEX_NAME')

export const getCourseIndex = () => getEnvVar('ALGOLIA_COURSE_INDEX_NAME')
